import gql from "graphql-tag";
import { useQuery as defaultUseQuery } from "@apollo/react-hooks";
import { useCurrentAccountId } from "@zapier/promotions/esm/hooks";
const currentPlanQuery = gql `
  query promotions_currentPlanQuery($accountId: Int!) {
    account(id: $accountId) {
      id
      currentPlan: planV2 {
        id
        interval
      }
    }
  }
`;
export const useCurrentPlan = ({ skip, ...props } = {}) => {
    var _a, _b;
    const useQuery = (_a = props.useQuery) !== null && _a !== void 0 ? _a : defaultUseQuery;
    const { accountId } = useCurrentAccountId({ skip, useQuery });
    const { data, error, loading } = useQuery(currentPlanQuery, {
        skip: skip || !accountId,
        variables: {
            accountId,
        },
    });
    return {
        currentPlan: (_b = data === null || data === void 0 ? void 0 : data.account) === null || _b === void 0 ? void 0 : _b.currentPlan,
        error,
        isLoading: loading,
    };
};

// @zapier/upsells@5.0.1 (c64b11b3c)
